<div class="header-wrapper">
  <div>
    <h1>Lista zestawów procedur</h1>
  </div>
  <div nz-flex [nzGap]="'small'" [nzVertical]="false">
    <div>
      <button nz-button nz-dropdown [nzDropdownMenu]="menu">
        {{
          filters().isMultiple === null
            ? 'Wszystkie'
            : filters().isMultiple
              ? 'Wielokrotne'
              : 'Pojedyncze'
        }}
        <nz-icon nzType="down" />
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="filters.update((f) => ({ ...f, isMultiple: true }))">
            Wielokrotne
          </li>
          <li nz-menu-item (click)="filters.update((f) => ({ ...f, isMultiple: false }))">
            Pojedyncze
          </li>
          <li nz-menu-item (click)="filters.update((f) => ({ ...f, isMultiple: null }))">
            Wszystkie
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <div>
      <button nz-button nz-dropdown [nzDropdownMenu]="typeMenu">
        {{ modalities().find((m) => m.code === filters().type)?.name || 'Wszystkie typy' }}
        <nz-icon nzType="down" />
      </button>
      <nz-dropdown-menu #typeMenu="nzDropdownMenu">
        <ul nz-menu>
          @for (item of modalities(); track $index) {
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, type: item.code }))">
              {{ item.name }}
            </li>
          }
          <li nz-menu-item (click)="filters.update((f) => ({ ...f, type: null }))">
            Wszystkie typy
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <input
      nz-input
      placeholder="Szukaj.."
      [ngModel]="filters().query"
      (ngModelChange)="queryChange($event)"
    />
  </div>
</div>

<nz-table
  #procedureSetsTable
  [nzData]="searchResult()?.results ?? []"
  [nzBordered]="true"
  [nzLoading]="loading()"
  [nzPageSize]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzTotal]="total"
  [nzFrontPagination]="false"
  (nzQueryParams)="onQueryParamsChange($event)"
  nzTableLayout="fixed"
>
  <thead>
    <tr>
      <th nzColumnKey="id" [nzSortFn]="true" [nzSortOrder]="'descend'">Id</th>
      <th nzColumnKey="base.type" [nzSortFn]="true">Typ</th>
      <th nzColumnKey="base.name" [nzSortFn]="true">Nazwa</th>
      <th nzColumnKey="base.description" [nzSortFn]="true">Opis</th>
      <th nzColumnKey="base.defaultEtcInMinutes" [nzSortFn]="true">Czas wykonania</th>
      <th>Liczba procedur</th>
      <th nzColumnKey="isHidden" [nzSortFn]="true">Widoczność</th>
      <th class="mhs-table-action-header">Akcja</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let procedureSet of procedureSetsTable.data">
      <td>{{ procedureSet.id }}</td>
      <td>
        <nz-tag nzColor="green">{{ procedureSet.type }}</nz-tag>
      </td>
      <td>{{ procedureSet.name }}</td>
      <td>{{ procedureSet.description }}</td>
      <td>
        {{ procedureSet.defaultEtcInMinutes ?? '-' }}
        @if (procedureSet.defaultEtcInMinutes) {
          <span>min</span>
        }
      </td>
      <td>{{ procedureSet.medServices?.length ?? 0 }}</td>
      <td>
        <div
          class="mhs-boolean-icon"
          [attr.aria-label]="procedureSet.isHidden ? 'Ukryty' : 'Widoczny'"
          [title]="procedureSet.isHidden ? 'Ukryty' : 'Widoczny'"
        >
          <nz-icon [nzType]="procedureSet.isHidden ? 'close' : 'check'" />
        </div>
      </td>
      <td class="mhs-table-actions-cell">
        <div class="mhs-table-actions" nz-flex [nzGap]="'small'" [nzVertical]="false">
          <button
            nz-button
            nzType="primary"
            nzShape="circle"
            (click)="detailsClick(procedureSet.id!)"
          >
            <nz-icon nzType="search" />
          </button>
          <a
            nz-dropdown
            [nzDropdownMenu]="userActionsMenu"
            nz-button
            nzType="default"
            nzShape="circle"
          >
            <nz-icon nzType="menu-fold" nzTheme="outline" />
          </a>
          <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="editProcedureSetClick(procedureSet.id!)">Edytuj</li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
